import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div
      data-testid="notfound-page"
      className="container-up flex flex-col items-center justify-center py-32 md:py-48 text-center"
    >
      <span className="section-label">Erreur 404</span>
      <h1 className="mt-6 font-serif text-6xl md:text-8xl tracking-tight">
        Page introuvable
      </h1>
      <p className="mt-6 max-w-md text-up-muted leading-relaxed">
        La page que vous cherchez s&apos;est peut-être envolée avec le vent de
        l&apos;Atlantique. Revenons à l&apos;essentiel.
      </p>
      <Link to="/" className="btn-primary mt-10 group" data-testid="notfound-back-btn">
        <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-0.5" />
        Retour à l&apos;accueil
      </Link>
    </div>
  );
}
